export const msalConfig = {
    auth: {
      clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID, 
      authority: "https://login.microsoftonline.com/common",
      redirectUri: window.location.origin,
    },
  };